import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa"; // Import eye icon from react-icons
import "./HomeworkPreview.css";
import { Breadcrumb } from 'react-bootstrap';
import classes from "./Myschedule.module.css";
import classes1 from "../PaperFormat/PaperFormat.module.css";
import SecBTN from '../../UI/SecBTN';
import { useLocation } from "react-router-dom";
import userService from "../../app/services/user.service";
import axios from "axios"; // Axios to make API requests
import { useNavigate } from "react-router-dom";
import Modals from "../../UI/Modals/Modals";
import { linkReplaceFn } from "../../utils/custom_funtions";
import Card from "../../UI/Card/Card";
import CustomModal from "../../UI/Modals/Modals";
import { toast } from 'react-toastify';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import { Delete } from '@mui/icons-material'; 

export const HomeworkPreview = ({previewData}) => {
  // const [previewData, setPreviewData] = useState([]);
  const [checkedQuestions, setCheckedQuestions] = useState({});
  const [checkedQuestionsQid, setCheckedQuestionsQid] = useState([]);
  const [previewQuestions,setPreviewQuestions]=useState([]);
  const [DppPreview,setDppPreview]=useState([]);
  const [qdataId,setqDataId]=useState(0);
  const [show, setShow] = useState(false);
  const [show1,setShow1]=useState(false);
  const [showPopUp,setShowPopUp]=useState(false);
  const [totalquestions,setTotalQuestions]=useState(0);

 
  // const location = useLocation();
  // const { preview_data } = location.state || {};
  // const p = preview_data;
  // const navigate = useNavigate();
  useEffect(() => {
   
  }, [previewData]);

  // const getPreviewData = () => {
  //   userService.PreviewList(pdata?.moduleId, pdata?.faculty_id, pdata?.batch, pdata?.subtoicId, pdata?.subjectId)
  //     .then(res => {
  //       setPreviewData(res.data.data);
  //       setTotalQuestions(res.data.total_all_questions);
  //       console.log(res.data);
  //     })
  //     .catch(err => {
  //       console.error('Failed to fetch homework modules', err);
  //     });
  // };

  // Handle checkbox toggle
  const handleCheckboxChange = (id) => {
    
    setCheckedQuestions(prevState => ({
      ...prevState,
      [id]: !prevState[id] 
    }));
  };
  const handleCheckboxChangeQid = (qid) => {
    
    setCheckedQuestionsQid(prevState => ([
      ...prevState,
      qid 
    ]));
  };

  // Handle Add more button

  const handleClose = () => {
    setShow(false);

  };

  // const handleAddMore = () => {
  //   navigate(-1);
  // }

  // Handle delete of checked questions
  const handleDeleteChecked = (id) => {
    // const checkedIds = Object.keys(checkedQuestions).filter(id => checkedQuestions[id]);

    // if (checkedIds.length === 0) {
    //   alert("No items selected for deletion.");
    //   return;
    // }

    const deleteApiUrl = `https://learning.motion.ac.in/motioneducation/api/v1/homework_remove?id[]=${id}`;

    // Make the DELETE request
    axios.delete(deleteApiUrl)
      .then(() => {
        // Filter out deleted items from the previewData
        const updatedData = previewData.filter(question => question.id !==id);
        previewData=updatedData;
        setCheckedQuestions({}); 
        window.location.reload();
       
        // alert("Deleted successfully!");
      })
      .catch(err => {
        console.error("Error deleting homework modules", err);
      });
  };

  const handlePreview=(id)=>{
    setqDataId(id);
    setShow(true);
    getPreviewQuestions(id);
  }

  const getPreviewQuestions=(id)=>{
    userService.PreviewQuestion(id)
    .then(res => {
      setPreviewQuestions(res.data.data);
      console.log(res.data.data);

    })
    .catch(err => {
      console.error('Failed to fetch homework modules', err);
    });
  }

  const handleDPPMoudule=(index)=>{

    setShow1(true);
    console.log(previewQuestions[index]);
    setDppPreview(previewQuestions[index].questions_list);
    console.log(DppPreview);
  }

  const handleUpdate=async ()=>{
    
    console.log(checkedQuestionsQid);
  //  const selectedQids = previewQuestions[0]?.module_id===3 ? previewQuestions.map(question=>question.excersie_type): checkedQuestionsQid;

     
     const payload = {
       id:qdataId,
      qids: checkedQuestionsQid
    };
    const response = await axios.post('https://learning.motion.ac.in/motioneducation/api/v1/homework_questions_review_save', payload);
      // Handle success response
      if(response.data.status===200){
        toast.success("Questions saved Sucessfully");
        console.log('Data saved successfully:', response.data);
        setCheckedQuestionsQid([])
        window.location.reload();
        }
        else{
          toast.error("Please Select Questions");
        }
  }
   
  const onHideHandler=()=>{
    setShowPopUp(false);
  }
  const yesHandler=()=>{

  }
  const noHandler=()=>{

  }

  return (
    <>
      <CustomModal show={show} size="lg"  onHide={()=>setShow(false)}>
        <div>
          <h5 className="mb-3 popup-heading">Selected Questions</h5>
        </div>
      <Card className= {`questions-card questions-card-11`}>
          {(previewQuestions[0]?.module_id===5? previewQuestions[0].questions_list:previewQuestions)?.map((question, index) => (
            <div key={question.qid} className={`question-item ${previewQuestions[0].module_id!=3? "":'preview-card'}`} >
              <div className="question-header">
                {previewQuestions[0].module_id ===5?"":
                <input
                  type="checkbox"
                  className="question-checkbox"
                  checked={checkedQuestions[index]} 
                  onChange={() => question.module_id===3?handleCheckboxChangeQid(question.excersie_type):handleCheckboxChangeQid(question.qid)} 
                />
                }
                <label className="question-number">
                  
                  {question.module_id==3 ? question.excersie_type:  `Question ${index + 1}`  }
                </label>
              </div>
              {question.module_id!=3 ?
              <div className="question-text">
                  
                   <p dangerouslySetInnerHTML={{
                    __html: linkReplaceFn(question.q_text)
                  }} />
              </div>
              : <div>
            <FaEye className="preview-icon" onClick={()=>handleDPPMoudule(index)} />
              </div>
             }
            </div>
          ))}
          {
            previewQuestions[0]?.module_id ===5 ? " ":
          <SecBTN  className={classes1.activate} onClick={handleUpdate}> Update & Save </SecBTN>
         }
        </Card>
      </CustomModal>
      <CustomModal show={show1} size="lg"  onHide={()=>setShow1(false)}>
        <div>
          <h5 className="mb-3 popup-heading">Selected Questions</h5>
        </div>
      <Card className= {`questions-card questions-card-11`}>
          {DppPreview?.map((question, index) => (
            <div key={question.qid} className={`question-item`} >
              <div className="question-header">
                <label className="question-number">
                  
                  { `Question ${index + 1}`  }
                </label>
              </div>
              
              <div className="question-text">
                  
                   <p dangerouslySetInnerHTML={{
                    __html: linkReplaceFn(question.q_text)
                  }} />
              </div>
              
        
            </div>
          ))}
        </Card>
      </CustomModal>

      <ConfirmationModal
        title="Do You Want to Assign Homework"
        show={showPopUp}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        noHandler={noHandler}
        
        confirmTxt="yes"
      />

      {/* <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>My Schedule</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>My Schedule</Breadcrumb.Item>
            <Breadcrumb.Item active>{"Homework > Preview"}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <SecBTN className={classes["sec-btn2"]} onClick={()=>setShowPopUp(true)}>Assign</SecBTN>
      </div> */}
    {previewData &&
      <div className="preview-container">
        {/* <div className="total_question">
          <p>All Modules Total Questions : {totalquestions}</p>
        </div> */}
        {previewData.map((question) => (
          <div key={question.id} className="preview-card">
            <div>
              {/* <input
                type="checkbox"
                className="question-checkbox" // Apply the checkbox style
                checked={checkedQuestions[question.id] || false} // Set checkbox value based on state
                onChange={() => handleCheckboxChange(question.id)}
              /> */}
              <span className="preview-text">{question.module} | {question.topic} | {question.sub_topic_name}</span>
              {/* <p className="question-count">Total Questions : {question.total_questions}</p> */}
            </div>
            <div className="icons-list">
            <FaEye className="preview-icon" onClick={()=>handlePreview(question.id)} />
            <Delete className="delete-icon delete-icon1" onClick={()=>handleDeleteChecked(question.id)}/>
            {/* <SecBTN className={classes1.activate} onClick={()=>handleDeleteChecked(question.id)}>Delete</SecBTN> */}
            </div>
          </div>
          
        ))}
         
      </div>
     }

       {/* <div className='action-btns btns-container'>
        <SecBTN className={classes1.activate} onClick={handleDeleteChecked}>Delete</SecBTN> 
        <SecBTN className={`${classes1.activate} sec-btn`} onClick={handleAddMore}>Add More</SecBTN>
      </div>   */}
    </>
  );
};
